import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import validateEmail from "@insite/client-framework/Common/Utilities/validateEmail";
import siteMessage from "@insite/client-framework/SiteMessage";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import signIn from "@insite/client-framework/Store/Context/Handlers/SignIn";
import { getCurrentPage, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SignInChangePasswordForm from "@insite/content-library/Widgets/SignIn/SignInChangePasswordForm";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Checkbox, { CheckboxProps } from "@insite/mobius/Checkbox";
import CheckboxGroup, { CheckboxGroupComponentProps } from "@insite/mobius/CheckboxGroup";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { IconProps } from "@insite/mobius/Icon/Icon";
import Eye from "@insite/mobius/Icons/Eye";
import EyeOff from "@insite/mobius/Icons/EyeOff";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import TextField, { TextFieldProps } from "@insite/mobius/TextField";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography/Typography";
import { getProp } from "@insite/mobius/utilities";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import toggleLoginDrawer from "@NA/Handlers/ADILoginDrawerHandler";
import recoverUsernamePassword from "@NA/Handlers/ADIRecoverUsernamePasswordHandler";
import Modal, { ModalPresentationProps } from "@NA/MobiusOverrides/Modal";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import ADIColors from "@NA/Utils/ADIColors";
import { getRememberedUserName } from "@NA/Utils/Utility";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";
// The below import is being used by P21 ----- P21 Change
import {getStatuscall} from "@NA/Services/ADIgetStatusCall"


import { clearCoveoTokenAndOrg } from "@NA/Services/ADICoveoService";

const enum fields {
    changePasswordInstructions = "changePasswordInstructions",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.changePasswordInstructions]: string;
    };
}

const mapStateToProps = (state: CustomApplicationState) => {
    const parsedQuery = parseQueryString<{ externalError?: string }>(getLocation(state).search);
    const isPLP = getCurrentPage(state).type;
    return {
        accountSettings: getSettingsCollection(state).accountSettings,
        externalError: parsedQuery.externalError,
        session: state.context.session,
        currentLocation: getLocation(state),
        toggleDrawer: state.ADIGlobalData.loginDrawerStore.loginDrawer,
        defaultReturnUrl: state.ADIGlobalData.loginDrawerStore.returnUrl,
        isPLP,
    };
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

const mapDispatchToProps = {
    signIn,
    toggleLoginDrawer,
    recoverUsernamePassword,
};

export interface SignInExistingAccountStyles {
    container?: InjectableCss;
    form?: InjectableCss;
    rememberMeCheckbox?: CheckboxProps;
    rememberMeCheckboxGroup?: CheckboxGroupComponentProps;
    userNameTextField?: TextFieldProps;
    signInGridContainer?: GridContainerProps;
    icon?: IconProps;
    passwordTextField?: TextFieldProps;
    signInButton?: ButtonPresentationProps;
    signInButtonGridItem?: GridItemProps;
    forgotPasswordGridItem?: GridItemProps;
    rememberMeGridItem?: GridItemProps;
    passwordGridItem?: GridItemProps;
    userNameGridItem?: GridItemProps;
    signInExistingAccountTitle?: TypographyProps;
    forgotPasswordLink?: LinkPresentationProps;
    resetPasswordModal?: ModalPresentationProps;
    changePasswordModal?: ModalPresentationProps;
    formErrorMessage?: InjectableCss;
}

export const signInExistingAccountStyles: SignInExistingAccountStyles = {
    container: {
        css: css`
              width: 100%
        height: 100%;
        border-radius: 0 !important;
        padding-top: 10px !important;
        padding-right: 5px !important;
        padding-bottom: 10px !important;
        cursor: default;
        margin-top: -0.1px !important;
        position: relative !important;
        
        `,
    },
    icon: {
        css: css`
            padding-top: 50px;
        `,
    },
    form: {
        css: css`
            padding: 0px 0px;
            margin-top: 6px;
        `,
    },
    signInExistingAccountTitle: {
        variant: "h2",
        css: css`
            font-family: "Nunito Sans", sans-serif;
            padding: 0;
            margin: 20px;
            margin-left: 0px;
            font-size: 24px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.43;
            letter-spacing: normal;
            text-align: left;
            color: #2d2926;
            cursor: default;
        `,
    },
    signInGridContainer: {
        offsetCss: css`
            margin: 0 auto;
            width: 100% !important;
        `,
    },
    userNameGridItem: {
        width: 12,
        css: css`
            padding: 0;

            label {
                margin-top: 0;
                font-size: 14px;
                font-weight: bold;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                text-align: left;
                color: #2d2926;
                margin-bottom: 4px;
            }
        `,
    },
    passwordGridItem: {
        width: 12,
        css: css`
            padding: 15px 0 0 0;
        `,
    },
    passwordTextField: {
        css: css`
            color: ${ADIColors.darkBlack3};
            padding-right: 31px !important;
            ::placeholder {
                color: ${ADIColors.gray3};
            }
        `,
    },
    userNameTextField: {
        css: css`
            color: ${ADIColors.darkBlack3};
            ::placeholder {
                color: ${ADIColors.gray3};
            }
        `,
    },
    signInButtonGridItem: {
        width: 12,
        css: css`
            padding: 0px 0px;
        `,
    },
    rememberMeGridItem: {
        width: 12,
        css: css`
            padding: 0 0 15px 0;
            margin-top: -10px !important;
        `,
    },
    forgotPasswordGridItem: {
        width: 12,
        css: css`
            padding: 10px 0 21px 0;
        `,
    },
    forgotPasswordLink: {
        css: css`
            font-size: 12px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.67;
            letter-spacing: normal;
            text-align: left;
            color: #006ae3;
            font-family: Nunito Sans;
            text-transform: none;
            margin-bottom: 0 !important;
        `,
        typographyProps: {
            size: 13,
        },
    },
    signInButton: {
        css: css`
            width: 100%;
            margin: 0 auto 24px;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                    `,
                    css`
                        width: 100%;
                    `,
                    null,
                    null,
                    null,
                ])}

            &:focus {
                outline: none;
            }
            &:focus-visible {
                outline-offset: 1px;
                outline-color: ${getProp("theme.focus.color", "#09f")};
                outline-style: ${getProp("theme.focus.style", "solid")};
                outline-width: ${getProp("theme.focus.width", "2px")};
            }
        `,
    },
    resetPasswordModal: {
        sizeVariant: "small",
    },
    changePasswordModal: {
        sizeVariant: "small",
        closeButtonProps: {
            css: css`
                padding: 0;
                left: 13px;
                top: -14px;
                position: relative;
                font-weight: 900;
                &:hover {
                    background: none;
                    border-color: #ffffff;
                }
                &:focus {
                    outline-width: 0px;
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            top: -10px;
                            left: 7px;
                        `,
                        css`
                            top: -10px;
                            left: 7px;
                        `,
                        css``,
                        null,
                        null,
                    ])}
            `,
        },
        cssOverrides: {
            modalContainer: css`
                position: fixed;
                /* height: 0; */
                padding: 0;
                background: none;
                border: none;
                box-shadow: none;
                /* text-align: center; */
                width: 100%;
                position: fixed;
                top: 52px;
                z-index: 99999;
                height: auto;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            top: 77px;
                            padding-top: 18px !important;
                        `,
                        css`
                            top: 77px;
                            padding-top: 18px !important;
                        `,
                        css`
                            top: 98px;
                        `,
                        css`
                            top: 98px;
                        `,
                        css`
                            //top: 3%;
                        `,
                    ])}
                > div[class^="ContentBody"] {
                    padding: 28px !important;
                    max-width: 383px;
                    background-color: white;
                    border-radius: 6px;
                    border: solid 1px #ddd;
                    -webkit-box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);
                    box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);
                    height: auto !important;
                    ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                                padding: 28px 15px !important;
                                margin: 10px;
                            `,
                        css`
                                padding: 28px 15px !important;
                                margin: 10px;
                            `,
                        css``,
                        css``,
                        css``,
                    ])}
                }
            `,
            modalBody: css`
                border-radius: 6px;
                height: 100px;
                margin: 50px;
            `,

            modalContent: css`
                padding: 0px !important;
            `,

            modalTitle: css`
                border-bottom: 0px;

                // .TypographyStyle{
                //     font-size: 28px;
                // }
                // font-size:28px;
                padding: 0px !important;
                font-family: "Nunito Sans", sans-serif;
                color: #002856;
                font-weight: 900;
                margin-bottom: 16px;
                font-size: 28px;
                height: 38px;
                h4 {
                    font-family: "Nunito Sans", sans-serif;
                    font-size: 28px;
                    font-weight: bold;
                    font-size: inherit;
                    text-align: left;
                    color: #002856;
                    ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                                font-size: 24px;
                                margin-bottom: 14px;
                            `,
                        css`
                                font-size: 24px;
                                margin-bottom: 14px;
                            `,
                    ])}
                }
                ${({ theme }: { theme: BaseTheme }) => breakpointMediaQueries(theme, [css``, css``])}
            `,
        },
    },
    formErrorMessage: {
        css: css`
            margin-bottom: 0px;
            font-size: 12px;
            font-weight: 600;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: left;
            color: ${ADIColors.danger};
            float: left;
            width: 100%;
        `,
    },
};

/**
 * @deprecated Use signInExistingAccountStyles instead.
 */
export const signInExistingAccount = signInExistingAccountStyles;
const styles = signInExistingAccountStyles;
const StyledForm = getStyledWrapper("form");

const SignInExistingAccount = ({
    signIn,
    fields,
    accountSettings,
    externalError,
    session,
    toggleLoginDrawer,
    currentLocation,
    toggleDrawer,
    history,
    defaultReturnUrl,
    recoverUsernamePassword,
    isPLP,
}: Props) => {
    const [rememberedUserName, setRememberedUserName] = useState(getRememberedUserName());
    const [rememberMe, setRememberMe] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [userName, setUserName] = useState(rememberedUserName || "");
    const [password, setPassword] = useState("");
    const [isSignInClicked, setIsSignInClicked] = useState(false);
    const [isResetPasswordModalOpen, setIsResetPasswordModalOpen] = useState(false);
    const [isChangePasswordModalOpen, setIsChangePasswordModalOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState(externalError || "");
    const [isUserNameError, setIsUserNameError] = useState(false);
    const [isPasswordError, setPasswordError] = useState(false);
    const [isGlobalError, setIsGlobalError] = useState(false);

    const [signInError, setSignInError] = useState("");
    const [loginAttempt, setLoginAttempt] = useState(1);
    const [disableSignIn, setDisableSignIn] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [showCustomerStatusBanner, setShowCustomerStatusBanner] = useState<boolean>();

    const signInFailed = (error: any) => {        
        setSignInError(error.message);
        setLoginAttempt(loginAttempt => loginAttempt + 1);
        setDisableSignIn(false);

        if (loginAttempt >= 2) {
            window.localStorage.setItem("userNameSA", userName);

            recoverUsernamePassword({
                userEmail: "noCaptchaValidation",
                passwordEmail: userName,
                isPasswordReset: true,
                isuserNameReset: false,
                userNotFound: false,
                isSuccess: false,
                uri: "",
                properties: { captchaResponse: "", isEmailSend: true },
                onSuccess: (result: any) => {
                    window.localStorage.setItem("isUserNameError", result.result.userNotFound);
                    window.location.href = "/MyAccount/signinassist";
                },
            });
        }
    };

    const showRememberMe = accountSettings.rememberMe;

    const isAuthenticated = session && (session.isAuthenticated || session.rememberMe) && !session.isGuest;


    const redirectskip = () =>{
        if (!!(isPLP && ["ProductDetailsPage","ProductListPage"].includes(isPLP)) || currentLocation.pathname == "/services/adi-pro-rewards" || currentLocation.pathname == "/MyAccount/MonthlyFlyer"){
            return true
        }
        else {
            return false
        }
    };

    const signInHandler = (newPassword?: string) => {
        const pass = newPassword || password;
        const user = (userName || rememberedUserName) as string;
        setIsSignInClicked(true);

        !user ? setIsUserNameError(true) : setIsUserNameError(false);

        !pass ? setPasswordError(true) : setPasswordError(false);
        const isGlobalErrorOccured = !user || !pass;

        setIsGlobalError(isGlobalErrorOccured);

        if (isGlobalErrorOccured) {
            return;
        }

        if (accountSettings.useEmailAsUserName && !validateEmail(user)) {
            return;
        }

        const queryParams = parseQueryString<{ returnUrl?: string }>(window.location.search);

        let returnUrl: any = "";
        if (currentLocation.pathname === "/MyAccount/recoverusernamepassword") {
            returnUrl = `/${currentLocation.search}`;
        }
        else {
            returnUrl = window.location.pathname + window.location.search + window.location.hash;
            const redirectUrl = window.sessionStorage.getItem("redirectAfterLogin") || null;
            returnUrl = redirectUrl ?? returnUrl;
        }

        setErrorMessage("");
        localStorage.removeItem("sessionStartTime");
        signIn({
            userName: user,
            password: pass,
            rememberMe,
            returnUrl: defaultReturnUrl ?? returnUrl,
            skipRedirect: true,
            onError: (error, statusCode) => {
                if (statusCode === 422) {
                    setIsChangePasswordModalOpen(true);
                    window.localStorage.setItem("isChangePasswordModalOpen", "true");
                    return;
                } else if (statusCode === 400) {                    
                    setErrorMessage(error);
                    signInFailed(error);
                    return;
                } else {
                    setErrorMessage(error);
                    signInFailed(error);
                }
            },
        });
        clearCoveoTokenAndOrg();
    };

    // The below function is being used by P21 ----- P21 Change
    async function getStatusCall(){
        await getStatuscall().then((response)=>{
        const  showCustomerStatusBanner=(response as any )?.response?.showCustomerStatusBanner
        setShowCustomerStatusBanner(showCustomerStatusBanner)
        localStorage.setItem("showCustomerStatusBanner",showCustomerStatusBanner)
        }).catch((err)=>{
           return err;
        })
    }

    useEffect(() => {
        if (session.isAuthenticated) {
           // getStatusCall();
            const dataLayer = (window as any).dataLayer || [];
            const userId = session && session.userProfileId;
            if (dataLayer) {
                dataLayer.push({ ecommerce: null });
                dataLayer.push({
                    event: "Successful login",
                    ecommerce: {
                        authenticationState: "Logged In",
                        userId: userId || "",
                    },
                });
            }
            //  return dataLayer;
        }
    }, [session.isAuthenticated]);

    useEffect(() => {
        const rememberMeValue = localStorage.getItem("rememberMe");
        setRememberMe(rememberMeValue === "true");
    }, []);

    useEffect(() => {
        if (rememberedUserName) {
            localStorage.setItem("rememberedUserName", rememberedUserName);
        }
    }, [rememberedUserName]);

    const submitHandler = (event: any) => {
        event.preventDefault();
        signInHandler();
        if (rememberMe) {
            localStorage.setItem("rememberMe", rememberMe.toString());
            localStorage.setItem("rememberedUserName", userName);
        } else {
            localStorage.setItem("rememberMe", rememberMe.toString());
            localStorage.setItem("rememberedUserName", "");
        }
    };

    const onResetPasswordClose = () => {
        setIsResetPasswordModalOpen(false);
    };

    const onChangePasswordClose = () => {
        setIsChangePasswordModalOpen(false);
        window.localStorage.setItem("isChangePasswordModalOpen", "false");
    };

    const onPasswordChanged = (newPassword: string) => {
        setPassword(newPassword);
        setIsChangePasswordModalOpen(false);
        window.localStorage.setItem("isChangePasswordModalOpen", "false");
        signInHandler(newPassword);
    };

    const validateUserName = () => {
        if (isSignInClicked) {
            if (userName) {
                if (accountSettings.useEmailAsUserName && !validateEmail(userName)) {
                    return siteMessage("SignInInfo_Email_Validation");
                }
            } else {
                return accountSettings.useEmailAsUserName
                    ? "*Please enter information in required fields"
                    : errorMessage || "";
            }
        }

        return "";
    };

    const forgetPasswordHandler = () => {
        if (toggleDrawer) {
            toggleLoginDrawer({ loginDrawer: false });
        }

        if (!isAuthenticated) {
            history.push("/MyAccount/recoverusernamepassword");
        }
    };

    const userErrorMessage = validateUserName();
    const passwordErrorMessage =
        !password && isSignInClicked ? "*Please enter information in required fields" : errorMessage || "";

    return (
        <StyledForm {...styles.container} onSubmit={submitHandler}>
            <Typography {...styles.signInExistingAccountTitle}>{translate("Sign In")}</Typography>
            <StyledWrapper {...styles.form}>
                <StyledWrapper {...styles.formErrorMessage}>
                    {passwordErrorMessage || userErrorMessage ? (
                        <Typography {...styles.formErrorMessage}>{passwordErrorMessage}</Typography>
                    ) : (
                            <Typography
                                style={{
                                    color: isGlobalError ? ADIColors.danger : "#2D2926",
                                    paddingLeft: "15px",
                                    display: "none",
                                }}
                            ></Typography>
                        )}
                </StyledWrapper>
                <GridContainer {...styles.signInGridContainer}>
                    <GridItem {...styles.userNameGridItem}>
                        <TextField
                            id="userName"
                            {...styles.userNameTextField}
                            label={accountSettings.useEmailAsUserName ? translate("Username") : translate("Username")}
                            onChange={e => {
                                setUserName(e.currentTarget.value);
                                setRememberedUserName("");
                            }}
                            value={userName}
                            error={userErrorMessage}
                            autoComplete="username"
                            data-test-selector="signIn_userName"
                            placeholder="Enter value here..."
                            style={{ borderColor: passwordErrorMessage ? ADIColors.danger : ADIColors.gray3 }}
                        />
                    </GridItem>
                    <GridItem {...styles.passwordGridItem}>
                        <TextField
                            id="password"
                            {...styles.passwordTextField}
                            label={translate("Password")}
                            onChange={e => setPassword(e.currentTarget.value)}
                            value={password}
                            iconProps={{
                                ...styles.icon,
                                src: showPassword ? Eye : EyeOff,
                            }}
                            iconClickableProps={{
                                onClick: () => {
                                    setShowPassword(!showPassword);
                                },
                                type: "button",
                            }}
                            clickableText={password}
                            autoComplete="current-password"
                            data-test-selector="signIn_password"
                            type={showPassword ? "text" : "password"}
                            placeholder="Enter value here..."
                            style={{ borderColor: passwordErrorMessage ? ADIColors.danger : ADIColors.gray3 }}
                        />
                    </GridItem>
                    <GridItem {...styles.forgotPasswordGridItem}>
                        <Link
                            {...styles.forgotPasswordLink}
                            type="button"
                            onClick={forgetPasswordHandler}
                            data-test-selector="signIn_forgotPassword"
                        >
                            {translate("Forgot username or password?")}
                        </Link>
                        {/* Removed this OOTB behavior code to call forgot password on Modal */}
                        {/* <Modal
                            headline={translate("Reset Password")}
                            {...styles.resetPasswordModal}
                            isOpen={isResetPasswordModalOpen}
                            handleClose={() => onResetPasswordClose()}
                            data-test-selector="resetPasswordModal"
                        >
                            <SignInResetPasswordForm onClose={() => onResetPasswordClose()} />
                        </Modal> */}
                    </GridItem>
                    <GridItem {...styles.rememberMeGridItem}>
                        {showRememberMe && (
                            <CheckboxGroup {...styles.rememberMeCheckboxGroup}>
                                <Checkbox
                                    uid="rememberMe"
                                    {...styles.rememberMeCheckbox}
                                    checked={rememberMe}
                                    onChange={(e, value) => setRememberMe(value)}
                                >
                                    {translate("Remember Me")}
                                </Checkbox>
                            </CheckboxGroup>
                        )}
                    </GridItem>
                </GridContainer>
            </StyledWrapper>
            <StyledWrapper {...styles.signInButtonGridItem}>
                <Button {...styles.signInButton} data-test-selector="signIn_submit" type="submit">
                    {translate("Sign In")}
                </Button>
                <Modal
                    headline={translate("Create New Password")}
                    {...styles.changePasswordModal}
                    isOpen={isChangePasswordModalOpen}
                    handleClose={onChangePasswordClose}
                >
                    <SignInChangePasswordForm
                        enteredUserName={userName}
                        enteredPassword={password}
                        instructionsText={fields.changePasswordInstructions}
                        onPasswordChanged={onPasswordChanged}
                    />
                </Modal>
            </StyledWrapper>
        </StyledForm>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(SignInExistingAccount)),
    definition: {
        group: "Sign In",
        icon: "LogIn",
        fieldDefinitions: [
            {
                fieldType: "Translatable",
                name: fields.changePasswordInstructions,
                editorTemplate: "RichTextField",
                displayName: "Change Password Instructions",
                defaultValue: "A password change is required for your account before you may continue.",
                extendedConfig: { height: 170 },
                expandedToolbarButtons: {
                    moreMisc: {},
                    code: {},
                },
            },
            {
                fieldType: "Translatable",
                name: fields.changePasswordInstructions,
                editorTemplate: "RichTextField",
                displayName: "Change Password Instructions",
                defaultValue: "A password change is required for your account before you may continue.",
                extendedConfig: { height: 170 },
                expandedToolbarButtons: {
                    moreMisc: {},
                    code: {},
                },
            },
        ],
    },
};

export default widgetModule;
